import { render, staticRenderFns } from "./Linkpath.vue?vue&type=template&id=53c86f71&"
import script from "./Linkpath.vue?vue&type=script&lang=js&"
export * from "./Linkpath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports